module.exports = __webpack_public_path__ + "static/img/wjj.8c007ff0.png";